import Bugsnag from '@bugsnag/js'

Bugsnag.start({
  apiKey: import.meta.env.VITE_BUGSNAG_API_KEY!,
  releaseStage: import.meta.env.VITE_RAILS_ENV,
  enabledReleaseStages: [ 'production', 'staging' ],
})